import React, { useEffect, useState } from 'react';

import * as S from './styled';
import Button from '../../Button';
import { ERROR_PAGE_BUTTON_MESSAGE, PAGE_ERROR_MESSAGE } from '../../../constants/service/common/pageConstants';
import { AxiosError } from 'axios';
import { ErrorResponseType, extractErrorMessage } from '../../../lib/utils/checkErrorResponse';
import { V1ApiError } from '../../../lib/superFetch';

interface IErrorSectionProps {
  error: AxiosError | V1ApiError;
  reset: () => void;
}

const ErrorSection = ({ error, reset }: IErrorSectionProps): JSX.Element => {
  const [statusCode, setStatusCode] = useState<number>(400);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const isNotAuthorized = statusCode === 401;
  const isNotFound = statusCode === 404;

  const onClickHandler = () => {
    if (isNotAuthorized) {
      localStorage.clear();
      window.location.reload();
    } else {
      reset();
    }
  };

  const subTitleFirst = isNotFound
    ? PAGE_ERROR_MESSAGE.PAGE_NOT_FOUND_MESSAGE
    : PAGE_ERROR_MESSAGE.UNABLE_TO_PROCESS_MESSAGE;

  useEffect(() => {
    if (error instanceof AxiosError) {
      setStatusCode(error.response?.status || 400);
      setErrorMessage(extractErrorMessage(error as ErrorResponseType));
    } else {
      setErrorMessage(error.message);
      setStatusCode(error.status);
    }
  }, [error]);

  return (
    <S.ErrorSectionWrapper>
      <S.ErrorSectionTextBox>
        <S.Status>{statusCode} Error</S.Status>
        <S.Title>{errorMessage}</S.Title>
        <S.SubText>
          <span>{subTitleFirst}</span>
          {isNotFound && <span>{PAGE_ERROR_MESSAGE.INVALID_URL_INPUT_MESSAGE}</span>}
        </S.SubText>
      </S.ErrorSectionTextBox>
      <Button
        color="primary"
        text={
          isNotAuthorized ? ERROR_PAGE_BUTTON_MESSAGE.REDIRECT_LOGIN : ERROR_PAGE_BUTTON_MESSAGE.REDIRECT_PREVIOUS_PAGE
        }
        onClick={onClickHandler}
      />
    </S.ErrorSectionWrapper>
  );
};

export default ErrorSection;
